import { Loader, TableCell, TableRow } from 'semantic-ui-react';
import { MapPin, RectangleDashed } from '@phosphor-icons/react';
import {
  ColoredPill,
  HoverBorderButton,
  MuteText,
  NormalSliderCheckbox,
} from '../../elements';
import { CommonUtility } from '../../utility';

export function PackagingMaterialRow({
  item,
  editMaterial,
  rowLoading,
  toggleActiveStatus,
  toggleDefaultStatus,
}) {
  return (
    <TableRow>
      <TableCell>{item.name}</TableCell>
      <TableCell>{item.packagingType}</TableCell>
      <TableCell>
        <div className="text-nowrap">
          <span>{CommonUtility.roundNumber(item.dimensions?.length)}</span>
          <MuteText className="mx-1">x</MuteText>
          <span>{CommonUtility.roundNumber(item.dimensions?.height)}</span>
          <MuteText className="mx-1">x</MuteText>
          <span>{CommonUtility.roundNumber(item.dimensions?.width)}</span>
          <MuteText className="ml-1">{item.dimensions?.uom}.</MuteText>
        </div>
      </TableCell>
      <TableCell>
        <div className="text-nowrap">
          <span>{CommonUtility.roundNumber(item.weight.value)}</span>
          <MuteText className="ml-1">{item.weight.uom}</MuteText>
        </div>
      </TableCell>
      <TableCell>
        <span>{item.useCase}</span>
      </TableCell>
      <TableCell>
        <ColoredPill color={item.locationId.zoneId.color}>
          <RectangleDashed />
          {item.locationId.zoneId.name}
        </ColoredPill>
        <ColoredPill color={item.locationId.zoneId.color} className="mt-2">
          <MapPin />
          {item.locationId.code}
        </ColoredPill>
      </TableCell>
      <TableCell>
        <div className="text-nowrap">
          {item.unitsAvailable} <MuteText>Units</MuteText>
        </div>
      </TableCell>
      <TableCell>
        <span className="text-nowrap">
          {CommonUtility.currencyFormat(item.price.value, item.price.currency)}
        </span>
      </TableCell>
      <TableCell>
        {rowLoading[item._id] ? (
          <Loader active inline size="small" />
        ) : (
          <NormalSliderCheckbox
            checked={item.status === 'active'}
            onChange={() => toggleActiveStatus(item)}
          />
        )}
      </TableCell>
      <TableCell>
        {rowLoading[item._id] ? (
          <Loader active inline size="small" />
        ) : (
          <NormalSliderCheckbox
            checked={item.isDefault}
            onChange={() => toggleDefaultStatus(item)}
            disabled={item.status !== 'active'}
          />
        )}
      </TableCell>
      <TableCell>
        <HoverBorderButton onClick={() => editMaterial(item)} className="text-nowrap">
          Edit
        </HoverBorderButton>
      </TableCell>
    </TableRow>
  );
}
